import styled from 'styled-components'

const Container = styled.div`
  padding: ${props =>
    props.size ? props.theme.spacing[props.size] : props.theme.spacing.xl};
`

export default Container
